export default {"src":"/_next/static/media/CVEO.b045c38b.svg","height":18,"width":18};